export default "__VITE_ASSET__DcSgLKY0__"